import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'currentUser',
    ])
  },
  methods: {
    // @vuese
    // Used ti check user role
    isRole(roleType) {
      return this.currentUser && this.currentUser.roles && this.currentUser.roles.includes(roleType);
    },

    isRolePresent() {
      return this.currentUser?.roles?.length > 0;
    },

    signedPolicy() {
      return this.currentUser?.policy_signed
    }
  }
};